<template>
  <!-- NOUVELLE SECTION : Statistiques des messages par client -->
  <div class="mb-4">
    <h4 class="mb-3 border-b-2 border-gray-300 pb-2">
      Statistiques des messages par botchat
    </h4>
    <!-- MODIFICATION ICI : Utilisation de flexbox pour l'alignement horizontal -->
    <div class="flex flex-wrap justify-content-start gap-3">
      <!-- Itérer sur chaque client dans clientStats -->
      <div
        v-for="(products, clientNumber) in clientStats"
        :key="clientNumber"
        class="flex-shrink-0"
        style="width: 280px"
      >
        <div class="card mb-0 w-full">
          <!-- w-full pour que la carte remplisse sa div parente -->
          <div class="flex justify-content-between align-items-center">
            <div>
              <span class="block text-500 font-medium mb-3"
                >Bot: {{ formatClientNumber(clientNumber) }}</span
              >
              <div class="text-900 font-medium text-xl">
                Messages reçus:
                {{ calculateTotal(products, "total_received") }}
              </div>
              <div class="text-900 font-medium text-xl">
                Messages envoyés:
                {{ calculateTotal(products, "sent_automatic_count") }}
              </div>
            </div>
            <div
              class="flex align-items-center justify-content-center bg-blue-100 border-round"
              style="width: 2.5rem; height: 2.5rem"
            >
              <i class="pi pi-user text-blue-500 text-xl"></i>
            </div>
          </div>
          <!-- Menu à trois points verticaux pour les détails -->
          <div class="flex justify-content-end mt-3">
            <Button
              icon="pi pi-ellipsis-v"
              class="p-button-text p-button-secondary"
              @click="$refs['clientMenu_' + clientNumber].toggle($event)"
            />
            <OverlayPanel
              :ref="'clientMenu_' + clientNumber"
              :dismissable="true"
            >
              <div class="p-menu">
                <div
                  class="p-menuitem"
                  @click="viewClientDetails(clientNumber)"
                >
                  <i class="pi pi-info-circle mr-2"></i>
                  <span>Voir les détails</span>
                </div>
              </div>
            </OverlayPanel>
          </div>
        </div>
      </div>
      <div v-if="Object.keys(clientStats).length === 0" class="col-12">
        <div class="card">
          <p class="text-center text-500">
            Aucune statistique de message client disponible.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <Toast />

    <!-- FIN NOUVELLE SECTION -->

    <h4 class="mb-3 border-b-2 border-gray-300 pb-2">Liste des produits</h4>

    <div class="flex justify-content-between flex-col sm:flex-row mb-4 gap-3">
      <Button
        label="Ajouter un produit"
        icon="pi pi-plus"
        class="mb-0"
        @click="showDialog = true"
      />

      <span class="p-input-icon-left w-full sm:w-auto">
        <!--<i class="pi pi-search" />-->
        <InputText
          v-model="globalFilter"
          placeholder="Rechercher"
          style="width: 100%"
        />
      </span>
    </div>

    <Dialog
      :header="dialogTitle"
      v-model:visible="showDialog"
      modal
      :style="{ width: isMobile ? '90vw' : '50vw' }"
      @hide="resetForm"
    >
      <br />

      <form @submit.prevent="editingId ? updateProduct() : createProduct()">
        <fieldset class="mb-6 border p-4 rounded shadow-sm">
          <legend class="font-bold text-blue-700">
            Informations Générales
          </legend>

          <span class="p-float-label">
            <InputText
              id="product_name"
              v-model="form.product_name"
              class="input-field"
            />
            <label for="product_name">Nom du produit</label>
          </span>
          <br />
          <br />

          <span class="p-float-label">
            <textarea
              id="product_url"
              v-model="form.product_url"
              class="input-field w-full resize-y overflow-hidden"
              @input="autoResize($event)"
            />
            <label for="product_url">Lien(s) produit(s)</label>
          </span>
          <small class="p-error">Séparer les liens par des espaces</small>
          <br />
          <br />

          <span class="p-float-label">
            <textarea
              id="key_product"
              v-model="form.key_product"
              class="w-full resize-y overflow-hidden"
              @input="autoResize($event)"
            />
            <label for="key_product">Mots-clés</label>
          </span>
          <small class="p-error">Séparer les mots-clés par des espaces</small>
        </fieldset>

        <!-- Le bouton Tiroir placé ici, avant les champs détaillés 
        <Button
          label="Tiroir"
          icon="pi pi-chevron-down"
          class="p-button-help mb-3"
          @click="showVariationsDrawer = !showVariationsDrawer"
        />

        <div
          v-if="showVariationsDrawer"
          class="variations-drawer p-3 border rounded mb-4"
        >-->
        <div
          v-for="(variation, index) in form.product_variations"
          :key="index"
          class="variation-item mb-4 p-3 border rounded"
          :class="[
            index % 5 === 0
              ? 'bg-blue-100'
              : index % 5 === 1
              ? 'bg-purple-100'
              : index % 5 === 2
              ? 'bg-yellow-100'
              : index % 5 === 3
              ? 'bg-pink-100'
              : 'bg-green-100',
          ]"
        >
          <section class="mb-4">
            <p class="font-bold text-sm mb-2">Messages (Texte ou Image)</p>
            <h2 class="variation-title">{{ index + 1 }}</h2>

            <span class="p-float-label pb-20">
              <!-- Libellés des colonnes -->

              <div class="flex items-center gap-2 mb-2 font-bold">
                <div class="w-20rem">Type</div>
                <div class="w-20rem">Texte ou image</div>
                <div class="w-auto"></div>
              </div>

              <!-- DRAGGABLE GLOBAL SUR LES BLOCS (texte ou image) -->
              <draggable
                v-model="variation.message_text"
                item-key="index"
                class="space-y-3"
              >
                <template #item="{ element: q, index: qIndex }">
                  <div class="flex items-center gap-2 mb-3">
                    <!-- Type (Texte / Image) -->
                    <Dropdown
                      v-model="q.type"
                      :options="[
                        { label: 'Texte', value: 'text' },
                        { label: 'Image', value: 'image' },
                      ]"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Type"
                      class="p-dropdown-trigger"
                      @change="onMessageTypeChange(q)"
                    />

                    <!-- Zone de contenu : texte ou image -->
                    <divs>
                      <!-- Texte -->
                      <textarea
                        v-if="q.type === 'text'"
                        v-model="q.message"
                        placeholder="Message"
                        class="w-full resize-y overflow-hidden"
                        @input="autoResize($event)"
                      />

                      <!-- Image -->
                      <!-- Image -->
                      <div v-else-if="q.type === 'image'" class="space-y-2">
                        <input
                          type="file"
                          @change="handleImageUploads($event, q)"
                          accept="image/*"
                        />

                        <!-- Affichage de l'image uploadée -->
                        <img
                          v-if="q.url"
                          :src="q.url"
                          alt="Aperçu"
                          class="w-24 h-24 object-cover rounded"
                          style="max-width: 100px"
                        />

                        <!-- Légende (caption) -->
                        <textarea
                          v-if="q.url"
                          v-model="q.caption"
                          placeholder="Légende"
                          class="w-full resize-y overflow-hidden"
                          @input="autoResize($event)"
                        />

                        <div
                          v-if="q.url"
                          class="field-checkbox flex items-center gap-2 mt-1"
                        >
                          <Checkbox
                            :inputId="'msg_img_active_' + index"
                            v-model="q.active"
                            :binary="true"
                          />
                          <label :for="'msg_img_active_' + index"></label>
                        </div>
                      </div>
                    </divs>

                    <!-- Supprimer le bloc -->
                    <Button
                      icon="pi pi-trash"
                      class="p-button-danger p-button-text"
                      @click="removeMessageBlock(index, qIndex)"
                      title="Supprimer ce bloc"
                    />
                  </div>
                </template>
              </draggable>

              <!-- Bouton d'ajout -->
              <Button
                label="Ajouter message"
                icon="pi pi-plus"
                class="p-button-success mt-3"
                @click="addMessageText(index)"
              />
            </span>
            <br />
            <br />

            <!--  <div class="field-checkbox mt-3 flex items-center gap-2">
              <Checkbox inputId="send_text_first" v-model="form.send_text_first" :binary="true" />
              <label for="send_text_first">Envoyer la description en premier</label>
            </div> -->

            <div class="mb-4">
              <p class="text-red-600 font-bold text-lg">
                Choix (Questions & Réponses)
              </p>

              <span class="p-float-label">
                <InputText
                  :id="'grand_titre_' + index"
                  v-model="variation.grand_titre"
                  class="input-field"
                />
                <label :for="'grand_titre_' + index">Grand titre</label>
                <small
                  :class="{ 'p-invalid': submitted && !variation.grand_titre }"
                ></small>
              </span>
              <br />
              <br />

              <span class="p-float-label">
                <InputText
                  :id="'bouton_text_' + index"
                  v-model="variation.bouton_text"
                  class="input-field"
                />
                <label :for="'bouton_text_' + index"
                  >Libellé bouton de sélection</label
                >
                <small
                  :class="{ 'p-invalid': submitted && !variation.bouton_text }"
                ></small>
              </span>
              <br />
              <br />

              <span class="p-float-label">
                <textarea
                  :id="'product_descriptif_' + index"
                  v-model="variation.product_descriptif"
                  class="w-full resize-y overflow-hidden"
                  @input="autoResize($event)"
                />
                <label :for="'product_descriptif_' + index"
                  >Descriptif produit</label
                >
                <small
                  :class="{
                    'p-invalid': submitted && !variation.product_descriptif,
                  }"
                ></small>
              </span>
              <br />
              <br />

              <!-- Libellés uniques des colonnes -->
              <div class="flex items-center gap-2 mb-2 font-bold">
                <div class="w-80rem">Question</div>
                <div class="w-20rem"></div>
                <div class="w-20rem"></div>
                <div class="w-auto"></div>
              </div>

              <div v-for="(q, qIndex) in variation.choix" :key="qIndex">
                <!-- Question -->
                <br />
                <br />
                <textarea
                  v-model="q.question"
                  placeholder="Question"
                  class="w-full resize-y overflow-hidden"
                  @input="autoResize($event)"
                />

                <!-- DRAGGABLE sur les réponses -->
                <draggable v-model="q.reponses" item-key="id" class="space-y-3">
                  <template #item="{ element: r, index: rIndex }">
                    <div
                      class="flex items-center gap-2 p-2 border rounded bg-white shadow-sm"
                    >
                      <!-- Type -->
                      <Dropdown
                        v-model="r.type"
                        :options="[
                          { label: 'Texte', value: 'text' },
                          { label: 'Image', value: 'image' },
                        ]"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Type"
                        class="p-dropdown-trigger"
                      />

                      <!-- Réponse texte -->
                      <textarea
                        v-if="r.type === 'text'"
                        v-model="r.value"
                        placeholder="Réponse texte"
                        class="w-full resize-y overflow-hidden"
                        @input="autoResize($event)"
                      />

                      <!-- Réponse image -->
                      <div v-else-if="r.type === 'image'">
                        <input
                          type="file"
                          @change="handleImageUploads($event, r)"
                          accept="image/*"
                        />

                        <img
                          v-if="r.url"
                          :src="r.url"
                          alt="aperçu"
                          class="w-24 h-24 object-cover rounded"
                          style="max-width: 100px"
                        />

                        <textarea
                          v-if="r.url"
                          v-model="r.caption"
                          placeholder="Légende"
                          class="w-full resize-y overflow-hidden"
                          @input="autoResize($event)"
                        />
                      </div>

                      <!-- Supprimer -->
                      <Button
                        icon="pi pi-trash"
                        class="p-button-danger p-button-text"
                        @click="removeResponse(q, rIndex)"
                      />
                    </div>
                  </template>
                </draggable>

                <!-- Ajouter une réponse -->
                <Button
                  label="Réponse au choix"
                  icon="pi pi-plus"
                  class="custom-plus-button mt-2"
                  @click="addResponse(variation, qIndex)"
                />

                <!-- Supprimer la question -->
                <Button
                  icon="pi pi-trash"
                  class="p-button-danger p-button-text mt-2"
                  @click="removeQuestion(variation, qIndex)"
                  title="Supprimer cette question"
                />
              </div>

              <Button
                label="Ajouter choix"
                icon="pi pi-plus"
                class="p-button-success mt-3"
                @click="addQuestion(index)"
              />

              <br />
              <br />
              <div class="field">
                <draggable
                  :list="form.images"
                  :key="form.images.length"
                  item-key="url"
                  class="space-y-3 mt-3"
                >
                  <template #item="{ element, index }">
                    <div
                      class="flex items-start gap-2 border rounded p-2 shadow-sm bg-white"
                    >
                      <div class="relative">
                        <img
                          :src="element.url"
                          alt="aperçu"
                          class="w-24 h-24 object-cover rounded"
                          style="max-width: 100px"
                        />

                        <!-- Numéro de l'image -->
                        <span
                          class="absolute top-0 left-0 bg-gray-800 text-white text-xs px-2 py-1 rounded-br"
                        >
                          #{{ index + 1 }}
                        </span>
                      </div>

                      <div class="flex flex-col flex-1">
                        <textarea
                          v-model="element.caption"
                          placeholder="Légende"
                          class="w-full resize-y overflow-hidden"
                          @input="autoResize($event)"
                        />
                        <i
                          class="pi pi-trash text-red-500 text-xl mt-2 cursor-pointer hover:text-red-700"
                          @click="removeImage(index)"
                        />
                      </div>
                    </div>
                  </template>
                </draggable>
              </div>
            </div>
          </section>

          <!-- Bouton pour supprimer cette variation -->
          <Button
            icon="pi pi-trash"
            class="p-button-danger p-button-text"
            @click="removeVariation(index)"
            title="Supprimer cette variation"
          />
          <!--  </div>-->

          <!-- Bouton pour ajouter une nouvelle variation -->
          <Button
            label="Ajouter un tiroir"
            icon="pi pi-plus"
            class="custom-button"
            @click="addVariation"
          />
        </div>

        <Button
          label="Enregistrer"
          type="submit"
          class="p-button-success mt-4"
          icon="pi pi-save"
        />
        <Button
          :label="editingId ? 'Supprimer' : 'Annuler'"
          class="p-button-secondary ml-2"
          export
          NODE_OPTIONS="--openssl-legacy-provider"
          icon="pi pi-times"
          @click="editingId ? confirmDelete(editingId) : cancelDialog()"
        />
      </form>
    </Dialog>
    <Divider />
    <DataTable
      :value="products"
      :paginator="true"
      :filteredValue="filteredProducts"
      :rows="rows"
      :rowClass="rowClass"
      :filters="filters"
      :totalRecords="totalRecords"
      :first="first"
      @page="onPage"
      :globalFilterFields="[
        'product_name',
        'product_url',
        'key_product',

        // 'message_to_send.text', // Cette ligne pourrait causer des problèmes avec le nouveau format, mieux de la retirer ou de la gérer dans une computed property pour la recherche
      ]"
      :globalFilter="globalFilter"
    >
      <Column header="Nom">
        <template #body="{ data }">
          <span v-tooltip.top="data.product_name">
            {{ truncate(data.product_name, 25) }}
          </span>
        </template>
      </Column>

      <Column header="Lien (s)">
        <template #body="{ data }">
          <span v-tooltip.top="data.product_url">
            {{ truncate(data.product_url, 40) }}
          </span>
        </template>
      </Column>

      <Column header="Clé(s) produit">
        <template #body="{ data }">
          <span v-tooltip.top="data.key_product">
            {{ truncate(data.key_product, 30) }}
          </span>
        </template>
      </Column>

      <!-- Texte du message -->
      <Column header="Contenu Message (Texte)">
        <template #body="{ data }">
          <div v-if="data.variations?.[0]?.message_to_send?.text">
            <div
              v-for="(item, idx) in data.variations[0].message_to_send.text"
              :key="idx"
            >
              <span v-if="item.type === 'text'" v-tooltip.top="item.message">
                {{ truncate(item.message, 30) }}
              </span>
            </div>
          </div>
        </template>
      </Column>

      <Column header="Contenu Message (Images)">
        <template #body="{ data }">
          <div class="image-thumbnails flex flex-wrap gap-2">
            <div
              v-for="(img, idx) in getAllImages(data.variations?.[0])"
              :key="idx"
              class="thumb-img"
              @click="openImageZoom(img.url, img.caption)"
            >
              <img
                v-if="img && img.url"
                :src="getFullImageUrl(img.url)"
                :alt="img.caption || 'Image'"
                class="w-full h-full object-cover"
              />
              <div class="caption text-xs text-center">
                {{ truncate(img.caption || "", 15) }}
              </div>
              <span
                class="absolute top-0 left-0 bg-gray-800 text-white text-xs px-1 rounded-br"
              >
                #{{ idx + 1 }}
              </span>
            </div>
          </div>
        </template>
      </Column>

      <Column header="">
        <template #header>
          <div
            @click="$refs.etatOverlay.toggle($event)"
            class="cursor-pointer select-none"
          >
            État <i class="pi pi-filter ml-1"></i>
          </div>
          <OverlayPanel ref="etatOverlay">
            <div class="flex flex-col space-y-2">
              <Button
                label="Tout"
                text
                @click="
                  filters.etat.value = null;
                  $refs.etatOverlay.hide();
                "
              />
              <Button
                label="Activé"
                text
                @click="
                  filters.etat.value = 1;
                  $refs.etatOverlay.hide();
                "
              />
              <Button
                label="Désactivé"
                text
                @click="
                  filters.etat.value = 0;
                  $refs.etatOverlay.hide();
                "
              />
            </div>
          </OverlayPanel>
        </template>

        <template #body="{ data }">
          <Button
            :label="data.etat ? 'Activé' : 'Désactivé'"
            :class="
              data.etat
                ? 'bg-green-500 hover:bg-green-600 text-white border-none'
                : 'bg-red-500 hover:bg-red-600 text-white border-none'
            "
            class="p-button-sm"
            disabled
          />
        </template>
      </Column>

      <Column header="Actions">
        <template #body="{ data }">
          <div class="flex justify-content-center">
            <Button
              icon="pi pi-ellipsis-v"
              class="p-button-text"
              @click="$refs['menu_' + data.product_id].toggle($event)"
            />
            <OverlayPanel :ref="'menu_' + data.product_id" :dismissable="true">
              <div class="p-menu">
                <div class="p-menuitem" @click="toggleActivation(data)">
                  <i class="pi pi-power-off mr-2"></i>
                  <span>{{ data.etat ? "Désactiver" : "Activer" }}</span>
                </div>

                <!--  <div class="p-menuitem" @click="duplicateProduct(data)">
            <i class="pi pi-copy mr-2"></i>
            <span>Dupliquer</span>
          </div> -->
                <div class="p-menuitem" @click="editProduct(data)">
                  <i class="pi pi-pencil mr-2"></i>
                  <span>Éditer</span>
                </div>
                <div class="p-menuitem" @click="confirmDelete(data.product_id)">
                  <i class="pi pi-trash mr-2 text-red-600"></i>
                  <span class="text-red-600">Supprimer</span>
                </div>
              </div>
            </OverlayPanel>
          </div>
        </template>
      </Column>
      <template #paginator>
        <div
          class="p-datatable-bottom flex justify-content-between align-items-center"
        >
          <Paginator
            :first="first"
            :rows="rows"
            :totalRecords="
              filteredProducts ? filteredProducts.length : products.length
            "
            @page="onPage"
          />
          <div class="text-sm text-gray-600">
            Total :
            {{ filteredProducts ? filteredProducts.length : products.length }}
            enregistrements
          </div>
        </div>
      </template>
    </DataTable>

    <div class="p-mt-2 text-right text-sm text-gray-600">
      Total : {{ filteredProducts ? filteredProducts.length : products.length }}
    </div>

    <Dialog
      v-model:visible="zoomDialog"
      modal
      :closable="true"
      :style="{ width: 'auto', maxWidth: '90vw' }"
      class="zoom-dialog"
    >
      <div class="zoom-content">
        <img :src="zoomImageUrl" alt="Zoom image" class="zoom-image" />
        <div class="zoom-caption">{{ zoomImageCaption }}</div>
      </div>
    </Dialog>
    <Dialog v-model:visible="confirmDialog" header="Confirmation" modal>
      <p>Voulez-vous vraiment supprimer ce produit ?</p>
      <div class="mt-3 text-right">
        <Button
          label="Annuler"
          class="p-button-secondary ml-2"
          icon="pi pi-times"
          @click="confirmDialog = false"
        />
        <Button
          label="Supprimer"
          class="p-button-danger ml-2"
          icon="pi pi-trash"
          @click="deleteConfirmed"
        />
      </div>
    </Dialog>
  </div>
</template>

<script>
import axios from "axios";
//import Toast from 'primevue/toast';
//import ToastService from 'primevue/toastservice';
//import { Checkbox } from 'primevue/checkbox';
import { InputText } from "primevue/inputtext";
//import { Textarea } from "primevue/textarea";
import { Button } from "primevue/button";
import { Divider } from "primevue/divider";
import { DataTable } from "primevue/datatable";
import { Column } from "primevue/column";
import Dialog from "primevue/dialog";
import { API_URL } from "../settings";
import draggable from "vuedraggable";
import { Dropdown } from "primevue/dropdown";

export default {
  components: {
    InputText,
    //Textarea,
    Button,
    Divider,
    DataTable,
    Column,
    Dialog,
    draggable,
    Dropdown,
  },
  data() {
    return {
      // product_variations: [
      //   {
      //     message_text: [],
      //     key_product: "",
      //     send_text_first: true,
      //     choix: [],
      //     grand_titre: "",
      //     bouton_text: "",
      //     product_descriptif: "",
      //   },
      // ],
      showVariationsDrawer: false,
      showDialog: false,
      isMobile: false,
      globalFilter: "",
      choix: [],
      filters: {
        global: { value: null, matchMode: "contains" },
        etat: { value: null, matchMode: "equals" },
      },

      etatOptions: [
        { label: "Tous", value: null },
        { label: "Activé", value: true },
        { label: "Désactivé", value: false },
      ],
      filteredProducts: [],
      first: 0, // index du premier élément affiché
      rows: 10, // éléments par page
      totalRecords: 0,
      form: {
        product_name: "",
        product_url: "",
        message_text: [],
        images: [],
        send_text_first: true, // <-- nouveau champ par défaut vrai
        key_product: "",
        choix: [],
        grand_titre: "",
        bouton_text: "",
        product_descriptif: "",
        product_variations: [
          {
            message_text: [],
            choix: [],
            grand_titre: "",
            bouton_text: "",
            product_descriptif: "",
          },
        ],
      },
      editingId: null,
      products: [],
      zoomDialog: false,
      zoomImageUrl: "",
      zoomImageCaption: "",
      submitted: false,
      confirmDialog: false,
      productToDeleteId: null,
      clientStats: {},
      statsInterval: null,
    };
  },
  mounted() {
    this.fetchProducts();
    this.statsInterval = setInterval(this.fetchMessageStats, 50000);
    this.checkScreen();
    window.addEventListener("resize", this.checkScreen);
  },

  beforeUnmount() {
    if (this.statsInterval) {
      clearInterval(this.statsInterval);
    }
    window.removeEventListener("resize", this.checkScreen);
  },
  computed: {
    dialogTitle() {
      return this.editingId ? "Modifier le produit" : "Ajouter un produit";
    },

    flattenedText(product) {
      if (!product.message_to_send?.text) return "";
      return product.message_to_send.text
        .filter((i) => i.type === "text")
        .map((i) => i.message)
        .join(" ");
    },
  },

  watch: {
    globalFilter(newVal) {
      this.filters["global"].value = newVal;
    },
  },

  methods: {
    autoResize(event) {
      const textarea = event.target;
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    },
    /*addVariation() {
      this.form.product_variations.push({
        message_text: [],
        send_text_first: true,
        choix: [],
        grand_titre: "",
        bouton_text: "",
        product_descriptif: "",
      });
    },*/

    addVariation() {
      this.form.product_variations.push({
        message_text: [
          { type: "text", message: "", active: true, fileObject: null },
        ],
        choix: [],
        grand_titre: "",
        bouton_text: "",
        product_descriptif: "",
      });
    },

    removeVariation(index) {
      this.form.product_variations.splice(index, 1);
    },
    async fetchMessageStats() {
      try {
        const response = await fetch(`${API_URL}api/mc_chat/message-stats`); // Ajustez l'URL si nécessaire
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (data.success) {
          console.log("Statistiques des messages brutes:", data.data);

          const groupedByClient = {};

          if (Array.isArray(data.data)) {
            data.data.forEach((item) => {
              const clientNumber = item.client_number;
              // Assurez-vous que ces compteurs sont des nombres, par défaut à 0 si null/undefined
              const receivedProductMatch =
                item.received_product_match_count || 0;
              const receivedListResponse =
                item.received_list_response_count || 0;
              const totalReceived = receivedProductMatch + receivedListResponse;
              const sentAutomatic = item.sent_automatic_count || 0;

              if (!groupedByClient[clientNumber]) {
                groupedByClient[clientNumber] = [];
              }

              groupedByClient[clientNumber].push({
                product_id: item.product_id,
                product_name: item.product_name,
                total_received: totalReceived,
                sent_automatic_count: sentAutomatic,
              });
            });
          } else {
            console.warn(
              "data.data n'est pas un tableau, impossible de regrouper les statistiques."
            );
          }

          this.clientStats = groupedByClient;
          console.log(
            "Statistiques des messages groupées par client:",
            this.clientStats
          );
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Erreur",
            detail:
              data.message ||
              "Erreur lors de la récupération des statistiques.",
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Erreur réseau ou autre:", error);
        this.$toast.add({
          severity: "error",
          summary: "Erreur",
          detail: "Impossible de charger les statistiques des messages.",
          life: 3000,
        });
      }
    },

    getAllImages(variation) {
      let images = [];

      // Sécurité : vérifier que variation et message_to_send existent
      if (!variation || !variation.message_to_send) return images;

      const message = variation.message_to_send;

      // 1. images dans message.text
      if (Array.isArray(message.text)) {
        message.text.forEach((item) => {
          if (item.type === "image" && item.active) {
            images.push(item);
          }
        });
      }

      // 2. images dans message.images
      if (Array.isArray(message.images)) {
        message.images.forEach((img) => {
          if (img.active) {
            images.push(img);
          }
        });
      }

      return images;
    },
    calculateTotal(products, key) {
      // Calcule la somme d'une clé spécifique à travers tous les produits pour un client donné
      return products.reduce((sum, product) => sum + (product[key] || 0), 0);
    },
    formatClientNumber(clientNumber) {
      // Formatage simple pour l'affichage, par exemple, supprimer "@c.us"
      if (clientNumber && typeof clientNumber === "string") {
        return clientNumber.replace("@c.us", "");
      }
      return clientNumber;
    },
    viewClientDetails(clientNumber) {
      // Générer l'URL vers la route /comptemessage
      const url = this.$router.resolve({
        path: "/comptemessage",
      }).href;

      // Ouvrir dans un nouvel onglet
      window.open(url, "_blank");

      // Affichage toast optionnel
      this.$toast.add({
        severity: "info",
        summary: "Détails client",
        detail: `Afficher les détails pour le client: ${this.formatClientNumber(
          clientNumber
        )}`,
        life: 3000,
      });

      console.log(`Navigating to /comptemessage for client: ${clientNumber}`);
    },
    addQuestion(variationIndex) {
      this.form.product_variations[variationIndex].choix.push({
        id: Date.now(),
        question: "",
        reponses: [],
      });
    },
    onImageSelected(event, question) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          question.reponse.value = e.target.result; // image encodée en base64
        };
        reader.readAsDataURL(file);
      }
    },

    onResponseTypeChange(question) {
      if (question.type === "image") {
        question.reponse = []; // tableau d’objets {url, caption}
      } else if (question.type === "text") {
        question.reponse = ""; // chaîne vide
      }
    },

    handleImageUpload(event, question) {
      const files = event.target.files;
      if (!files.length) return;

      for (const file of files) {
        const reader = new FileReader();
        reader.onload = (e) => {
          question.reponse.push({
            url: e.target.result,
            caption: "",
            fileObject: file, // Store the file object for FormData
            active: true, // NOUVEAU : Initialise l'état actif
          });
        };
        reader.readAsDataURL(file);
      }
    },

    handleImageUploads(event, item) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        item.url = e.target.result; // => C’est ça qui déclenche l’affichage
        item.fileObject = file; // Store the file object for FormData
        item.active = true; // NOUVEAU : Initialise l'état actif
      };
      reader.readAsDataURL(file);
    },

    handleImageUploadsForResponse(event, response) {
      const file = event.target.files[0];
      if (!file) return;

      // Générer un ID temporaire unique
      const tempId = `rep_img_${Date.now()}_${Math.random()
        .toString(36)
        .substr(2, 9)}`;

      // Stocker le fichier pour l'upload
      response.fileObject = file;
      // Remplacer url par l'ID temporaire (pas la base64)
      response.url = tempId;
      response.active = true;
    },

    removeImageFromResponse(question, index) {
      question.reponse.splice(index, 1);
    },

    /*removeQuestion(index) {
      this.form.choix.splice(index, 1);
      this.reindexChoix();
    },*/

    removeQuestion(variation, questionIndex) {
      variation.choix.splice(questionIndex, 1);
    },

    reindexChoix() {
      this.form.choix.forEach((item, index) => {
        item.id = `option${index + 1}`;
      });
    },

    /** -------------------
     * Gestion des réponses
     ------------------- **/

    addResponse(variation, questionIndex) {
      variation.choix[questionIndex].reponses.push({
        id: Date.now(),
        type: "text",
        value: "",
        url: null,
        caption: "",
      });
    },

    removeResponse(q, index) {
      q.reponses.splice(index, 1);
    },
    addMessageText(variationIndex) {
      this.form.product_variations[variationIndex].message_text.push({
        type: "text",
        message: "",
        url: "",
        caption: "",
        active: true,
      });
    },

    onMessageTypeChange(element) {
      if (element.type === "text") {
        element.message = ""; // <-- Correction: utiliser element.message
        element.url = ""; // Effacer l'URL et la caption si on passe en texte
        element.caption = "";
        element.active = true;
      } else if (element.type === "image") {
        element.url = "";
        element.caption = "";
        element.message = ""; // Effacer le message si on passe en image
        element.active = true;
      }
    },

    onMessageImageUpload(event, element) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        element.url = e.target.result;
        element.fileObject = file; // Store the file object
        element.active = true; // NOUVEAU : Initialise l'état actif
      };
      reader.readAsDataURL(file);
    },

    // Passer les deux indices : variationIndex et messageIndex
    removeMessageBlock(variationIndex, messageIndex) {
      const variation = this.form.product_variations[variationIndex];
      if (variation && Array.isArray(variation.message_text)) {
        variation.message_text.splice(messageIndex, 1);
      }
    },

    cancelDialog() {
      if (this.editingId) {
        // Ouvre la boîte de confirmation pour supprimer le produit en édition
        this.confirmDelete(this.editingId);
      } else {
        // Sinon, juste fermer le dialogue et reset le formulaire
        this.showDialog = false;
        this.resetForm();
      }

      this.showDialog = false;
    },

    checkScreen() {
      this.isMobile = window.innerWidth <= 768;
    },
    onFilter(event) {
      this.filteredProducts = event.filteredValue;
    },
    // async fetchProducts(/*page = 1*/) {
    //   try {
    //     const res = await axios.get(
    //       // `/api/mc_chat/products?page=${page}&limit=${this.rows}`
    //       `/api/mc_chat/products`
    //     );
    //     const data = res.data;

    //     // forcer data.items à être un tableau
    //     const items = Array.isArray(data.items) ? data.items : [];

    //     this.products = items.map((p) => {
    //       // message_to_send global
    //       if (typeof p.message_to_send === "string") {
    //         try {
    //           p.message_to_send = JSON.parse(p.message_to_send);
    //         } catch {
    //           p.message_to_send = { text: [], images: [] };
    //         }
    //       }
    //       if (!p.message_to_send) p.message_to_send = { text: [], images: [] };

    //       // variations
    //       const variations = Array.isArray(p.variations) ? p.variations : [];
    //       p.variations = variations.map((v) => {
    //         // message_to_send variation
    //         if (typeof v.message_to_send === "string") {
    //           try {
    //             v.message_to_send = JSON.parse(v.message_to_send);
    //           } catch {
    //             v.message_to_send = { text: [], images: [] };
    //           }
    //         }
    //         if (!v.message_to_send)
    //           v.message_to_send = { text: [], images: [] };

    //         // initialiser message_text
    //         v.message_text = [];
    //         const textArray = Array.isArray(v.message_to_send.text)
    //           ? v.message_to_send.text
    //           : v.message_to_send.text
    //           ? [v.message_to_send.text]
    //           : [];
    //         v.message_text.push(
    //           ...textArray.map((t) => ({ type: "text", message: t }))
    //         );

    //         const imagesArray = Array.isArray(v.message_to_send.images)
    //           ? v.message_to_send.images
    //           : [];
    //         v.message_text.push(
    //           ...imagesArray.map((img) => ({
    //             type: "image",
    //             url: img.url,
    //             caption: img.caption || "",
    //             active: true,
    //           }))
    //         );

    //         // choix
    //         if (typeof v.choix === "string") {
    //           try {
    //             v.choix = JSON.parse(v.choix);
    //           } catch {
    //             v.choix = [];
    //           }
    //         }
    //         v.choix = Array.isArray(v.choix) ? v.choix : [];

    //         // initialiser reponses pour chaque choix
    //         v.choix = v.choix.map((c) => ({
    //           ...c,
    //           reponses: Array.isArray(c.reponses)
    //             ? c.reponses
    //                 .map((r) => {
    //                   if (typeof r === "string") {
    //                     return { type: "text", value: r };
    //                   } else if (typeof r === "object" && r !== null) {
    //                     return r; // on garde l'objet tel quel (text ou image)
    //                   } else {
    //                     return null;
    //                   }
    //                 })
    //                 .filter(Boolean)
    //             : [],
    //         }));

    //         return v;
    //       });

    //       return p;
    //     });

    //     console.log("products", this.products);
    //     this.filteredProducts = this.products;
    //     this.totalRecords = data.totalItems || 0;
    //     this.currentPage = data.currentPage || 1;
    //   } catch (err) {
    //     console.error("Erreur fetchProducts:", err);
    //   }
    // },

    async fetchProducts() {
      try {
        const res = await axios.get(`/api/mc_chat/products`);
        const data = res.data;

        const items = Array.isArray(data.items) ? data.items : [];

        this.products = items.map((p) => {
          // === 1. Traiter message_to_send du produit ===
          if (typeof p.message_to_send === "string") {
            try {
              p.message_to_send = JSON.parse(p.message_to_send);
            } catch {
              p.message_to_send = { text: [], images: [] };
            }
          }
          if (!p.message_to_send) p.message_to_send = { text: [], images: [] };

          // === 2. Construire message_text pour produit ===
          p.message_text = [];

          const pTextArray = Array.isArray(p.message_to_send.text)
            ? p.message_to_send.text
            : p.message_to_send.text
            ? [p.message_to_send.text]
            : [];
          p.message_text.push(
            ...pTextArray.map((t) => ({ type: "text", message: t }))
          );

          const pImagesArray = Array.isArray(p.message_to_send.images)
            ? p.message_to_send.images
            : [];
          p.message_text.push(
            ...pImagesArray
              .map((img) => {
                if (typeof img === "string") {
                  return {
                    type: "image",
                    url: img,
                    caption: "",
                    active: true,
                  };
                } else if (typeof img === "object" && img !== null) {
                  return {
                    type: "image",
                    url: img.url,
                    caption: img.caption || "",
                    active: img.active !== false,
                  };
                }
                return null;
              })
              .filter(Boolean)
          );

          // === 3. Traiter les variations ===
          const variations = Array.isArray(p.variations) ? p.variations : [];
          p.variations = variations.map((v) => {
            // -- message_to_send
            if (typeof v.message_to_send === "string") {
              try {
                v.message_to_send = JSON.parse(v.message_to_send);
              } catch {
                v.message_to_send = { text: [], images: [] };
              }
            }
            if (!v.message_to_send)
              v.message_to_send = { text: [], images: [] };

            // -- Initialiser message_text
            v.message_text = [];

            const textArray = Array.isArray(v.message_to_send.text)
              ? v.message_to_send.text
              : v.message_to_send.text
              ? [v.message_to_send.text]
              : [];

            v.message_text.push(
              ...textArray.map((t) => ({ type: "text", message: t }))
            );

            const imagesArray = Array.isArray(v.message_to_send.images)
              ? v.message_to_send.images
              : [];

            v.message_text.push(
              ...imagesArray
                .map((img) => {
                  if (typeof img === "string") {
                    return {
                      type: "image",
                      url: img,
                      caption: "",
                      active: true,
                    };
                  } else if (typeof img === "object" && img !== null) {
                    return {
                      type: "image",
                      url: img.url,
                      caption: img.caption || "",
                      active: img.active !== false,
                    };
                  }
                  return null;
                })
                .filter(Boolean)
            );

            // -- choix
            if (typeof v.choix === "string") {
              try {
                v.choix = JSON.parse(v.choix);
              } catch {
                v.choix = [];
              }
            }
            v.choix = Array.isArray(v.choix) ? v.choix : [];

            // -- Traiter chaque choix
            v.choix = v.choix.map((c) => {
              let reponses = Array.isArray(c.reponses)
                ? c.reponses
                : c.reponses
                ? [c.reponses]
                : [];

              // S'assurer que les réponses sont au bon format
              reponses = reponses
                .map((r) => {
                  if (typeof r === "string") {
                    return { type: "text", value: r };
                  } else if (typeof r === "object" && r !== null) {
                    return r;
                  }
                  return null;
                })
                .filter(Boolean);

              // Ajouter question et réponses dans message_text
              if (c.question) {
                v.message_text.push({ type: "text", message: c.question });
              }

              reponses.forEach((r) => {
                if (r.type === "text" && r.value) {
                  v.message_text.push({ type: "text", message: r.value });
                } else if (r.type === "image" && r.url) {
                  v.message_text.push({
                    type: "image",
                    url: r.url,
                    caption: r.caption || "",
                    active: r.active !== false,
                  });
                }
              });

              return { ...c, reponses };
            });

            return v;
          });

          return p;
        });

        this.filteredProducts = this.products;
        this.totalRecords = data.totalItems || 0;
        this.currentPage = data.currentPage || 1;

        console.log("✅ Produits chargés :", this.products);
      } catch (err) {
        console.error("❌ Erreur fetchProducts:", err);
      }
    },

    // Quand l'utilisateur change de page dans DataTable
    onPage(event) {
      const page = Math.floor(event.first / event.rows) + 1;
      this.fetchProducts(page);
    },

    rowClass(data, index) {
      return index % 2 === 0 ? "row-paire" : "row-impaire";
    },

    truncate(textOrArray, length = 30) {
      if (!textOrArray) return "";

      // Si c'est un tableau, on concatène les messages texte et on tronque
      if (Array.isArray(textOrArray)) {
        // Extraire uniquement les messages texte (type === 'text')
        const combinedText = textOrArray
          .filter(
            (item) => item.type === "text" && typeof item.message === "string"
          )
          .map((item) => item.message)
          .join(" ");

        if (combinedText.length > length) {
          return combinedText.substring(0, length) + "…";
        }
        return combinedText;
      }

      // Si c'est une chaîne de caractères
      if (typeof textOrArray === "string") {
        if (textOrArray.length > length) {
          return textOrArray.substring(0, length) + "…";
        }
        return textOrArray;
      }

      // Pour tout autre type, retourner chaîne vide
      return "";
    },
    resetForm() {
      this.form = {
        product_name: "",
        product_url: "",
        message_text: [],
        images: [],
        choix: [], // Déjà présent, c'est bien
        send_text_first: false, // Ajouté
        key_product: "", // Ajouté
        grand_titre: "", // Ajouté
        bouton_text: "", // Ajouté
        product_descriptif: "", // Ajouté
      };
      this.submitted = false;
      this.editingId = null;

      // Les propriétés liées à la gestion du zoom d'image (si elles sont toujours utilisées et non rattachées à un composant séparé)
      this.zoomDialog = false;
      this.zoomImageUrl = "";
      this.zoomImageCaption = "";
    },
    handleFileUpload(event) {
      const files = event.target.files;

      for (let i = 0; i < files.length; i++) {
        if (this.form.images.length >= 5) {
          this.$toast.add({
            severity: "warn",
            summary: "Limite atteinte",
            detail: "Vous ne pouvez ajouter que 5 images",
            life: 3000,
          });
          break;
        }

        const file = files[i];
        const reader = new FileReader();

        reader.onload = (e) => {
          this.form.images.push({
            file,
            url: e.target.result,
            caption: "",
          });
        };

        reader.readAsDataURL(file);
      }

      // Réinitialiser le champ fichier pour pouvoir rechoisir les mêmes fichiers
      event.target.value = "";
    },

    removeImage(index) {
      this.form.images.splice(index, 1);
    },

    async updateProduct() {
      this.submitted = true;

      const formData = new FormData();
      const filesToUpload = new Map();

      // Nettoyer les variations
      const cleanedVariations = this.form.product_variations.map(
        (variation) => {
          // 1. Nettoyer message_text
          const cleanedMessageText = (variation.message_text || []).map(
            (item) => {
              if (item.type === "image" && item.fileObject) {
                const uniqueId =
                  item.id ||
                  `msg_img_${Date.now()}_${Math.random()
                    .toString(36)
                    .substr(2, 9)}`;
                filesToUpload.set(uniqueId, {
                  file: item.fileObject,
                  caption: item.caption,
                  active: item.active,
                });
                return {
                  type: "image",
                  id: uniqueId,
                  caption: item.caption,
                  active: item.active !== undefined ? item.active : true,
                };
              } else if (item.type === "image" && item.url) {
                return {
                  type: "image",
                  url: item.url,
                  caption: item.caption,
                  active: item.active !== undefined ? item.active : true,
                };
              }
              return item; // texte
            }
          );

          // 2. Nettoyer choix et réponses
          const cleanedChoix = (variation.choix || []).map((question) => {
            const cleanedReponses = (question.reponses || []).map((rep) => {
              if (rep.type === "image" && rep.fileObject) {
                const uniqueId =
                  rep.id ||
                  `rep_img_${Date.now()}_${Math.random()
                    .toString(36)
                    .substr(2, 9)}`;
                filesToUpload.set(uniqueId, {
                  file: rep.fileObject,
                  caption: rep.caption,
                  active: rep.active,
                });
                return {
                  type: "image",
                  id: uniqueId,
                  caption: rep.caption,
                  active: rep.active !== undefined ? rep.active : true,
                };
              } else if (rep.type === "image" && rep.url) {
                return {
                  type: "image",
                  url: rep.url,
                  caption: rep.caption,
                  active: rep.active !== undefined ? rep.active : true,
                };
              }
              return rep; // texte
            });
            return { ...question, reponses: cleanedReponses };
          });

          return {
            ...variation,
            message_text: cleanedMessageText,
            choix: cleanedChoix,
          };
        }
      );

      // Ajouter les variations dans le formData
      formData.append("variations", JSON.stringify(cleanedVariations));

      // Ajouter les fichiers dans formData
      filesToUpload.forEach((data, id) => {
        formData.append(`file_${id}`, data.file);
        formData.append(`caption_${id}`, data.caption || "");
        formData.append(`active_${id}`, data.active ? "1" : "0");
      });

      // Ajouter les autres champs
      formData.append("product_name", this.form.product_name);
      formData.append("product_url", this.form.product_url);
      formData.append("key_product", this.form.key_product);
      formData.append("send_text_first", this.form.send_text_first ? "1" : "0");

      try {
        const response = await axios.put(
          `${API_URL}api/mc_chat/product/${this.editingId}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        if (response.data && !response.data.error) {
          this.$toast.add({
            severity: "success",
            summary: "Succès",
            detail: response.data.message || "Produit mis à jour",
            life: 3000,
          });
          this.showDialog = false;
          this.resetForm();
          this.fetchProducts();
        } else {
          this.$toast.add({
            severity: "warn",
            summary: "Attention",
            detail: response.data.message || "Erreur de mise à jour",
            life: 3000,
          });
        }
      } catch (error) {
        const msg = error.response?.data?.message || "Erreur serveur";
        this.$toast.add({
          severity: "error",
          summary: "Erreur",
          detail: msg,
          life: 3000,
        });
      }
    },

    getFullImageUrl(relativePath) {
      if (!relativePath || typeof relativePath !== "string") {
        return ""; // ou une image par défaut si tu veux
      }

      if (relativePath.startsWith("/")) {
        return `${API_URL}${relativePath}`;
      }

      return relativePath;
    },

    openImageZoom(url, caption) {
      this.zoomImageUrl = url.startsWith("/") ? API_URL + url : url;
      this.zoomImageCaption = caption;
      this.zoomDialog = true;
    },

    base64ToFile(base64String, filename = "image.png") {
      const arr = base64String.split(",");
      const mimeMatch = arr[0].match(/:(.*?);/);
      const mime = mimeMatch ? mimeMatch[1] : "image/png";
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },

    async createProduct() {
      try {
        const formData = new FormData();
        const filesToUpload = new Map();

        // Nettoyer les variations
        const cleanedVariations = this.form.product_variations.map(
          (variation) => {
            // Nettoyer message_text (similaire à ce que tu as déjà)
            const cleanedMessageText = (variation.message_text || []).map(
              (item) => {
                if (item.type === "image" && item.fileObject) {
                  // S'il y a un nouveau fichier à uploader
                  const uniqueId =
                    item.id ||
                    `msg_img_${Date.now()}_${Math.random()
                      .toString(36)
                      .substr(2, 9)}`;
                  filesToUpload.set(uniqueId, {
                    file: item.fileObject,
                    caption: item.caption,
                    active: item.active,
                  });
                  return {
                    type: "image",
                    id: uniqueId,
                    caption: item.caption,
                    active: item.active !== undefined ? item.active : true,
                  }; // Envoyer l'ID et la légende
                }
                return item;
              }
            );

            // Nettoyer choix et réponses
            const cleanedChoix = (variation.choix || []).map((question) => {
              const cleanedReponses = (question.reponses || []).map((rep) => {
                if (rep.type === "image" && rep.fileObject) {
                  // S'il y a un nouveau fichier à uploader
                  const uniqueId =
                    rep.id ||
                    `rep_img_${Date.now()}_${Math.random()
                      .toString(36)
                      .substr(2, 9)}`;
                  filesToUpload.set(uniqueId, {
                    file: rep.fileObject,
                    caption: rep.caption,
                    active: rep.active,
                  });
                  return {
                    type: "image",
                    id: uniqueId,
                    caption: rep.caption,
                    active: rep.active !== undefined ? rep.active : true,
                  };
                }
                return rep;
              });
              return { ...question, reponses: cleanedReponses };
            });

            return {
              ...variation,
              message_text: cleanedMessageText,
              choix: cleanedChoix,
            };
          }
        );

        // Ajouter les données JSON dans formData
        formData.append("variations", JSON.stringify(cleanedVariations));

        // Ajouter les fichiers dans formData
        filesToUpload.forEach((fileData, key) => {
          formData.append(`file_${key}`, fileData.file); // Changer le nom de clé pour "file_"
          formData.append(`caption_${key}`, fileData.caption || ""); // Ajouter la légende
          formData.append(`active_${key}`, fileData.active ? "1" : "0"); // Ajouter l'état actif
        });

        // Ajouter autres champs
        formData.append("product_name", this.form.product_name || "");
        formData.append("product_url", this.form.product_url || "");
        formData.append("key_product", this.form.key_product || "");
        formData.append(
          "send_text_first",
          this.form.send_text_first ? "1" : "0"
        );

        // Envoi axios
        const response = await axios.post(
          `${API_URL}api/mc_chat/products`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        if (response.data.success) {
          this.$toast.add({
            severity: "success",
            summary: "Succès",
            detail: "Produit créé !",
          });
          this.showDialog = false;
          this.fetchProducts();
          this.resetForm();
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Erreur",
            detail: response.data.message || "Erreur lors de la création",
          });
        }
      } catch (error) {
        console.error("Erreur lors de la création du produit :", error);
        this.$toast.add({
          severity: "error",
          summary: "Erreur",
          detail: "Erreur lors de la création du produit",
        });
      }
    },

    editProduct(product) {
      try {
        const cleanProductUrl = (str) => {
          if (!str) return "";
          if (typeof str !== "string") return "";

          let s = str.trim();

          // Supprimer "undefined" au début suivi optionnellement d'un saut de ligne
          if (s.startsWith("undefined")) {
            s = s.slice("undefined".length).trimStart();
          }

          return s;
        };

        this.form = {
          product_name: cleanProductUrl(product.product_name),
          product_url: cleanProductUrl(product.product_url),
          key_product: cleanProductUrl(product.key_product),
          grand_titre: cleanProductUrl(product.grand_titre),
          bouton_text: cleanProductUrl(product.bouton_text),
          product_descriptif: cleanProductUrl(product.product_descriptif),
          send_text_first: product.send_text_first === 1,
          images: [],

          product_variations: (product.variations || []).map((variation) => {
            const v = { ...variation };

            const msg = v.message_to_send || { text: [], images: [] };
            const texts = Array.isArray(msg.text) ? msg.text : [];
            const images = Array.isArray(msg.images) ? msg.images : [];

            const message_text = [
              ...texts.map((m) => ({
                ...m,
                active: m.active !== undefined ? m.active : true,
                fileObject: null,
                url: m.url ? this.getFullImageUrl(m.url) : undefined,
              })),
              ...images.map((img) => ({
                type: "image",
                url: this.getFullImageUrl(img.url),
                caption: img.caption || "",
                active: img.active !== undefined ? img.active : true,
                fileObject: null,
              })),
            ];

            const choix = Array.isArray(v.choix)
              ? v.choix.map((q) => {
                  if (Array.isArray(q.reponses)) {
                    q.reponses = q.reponses.map((r) => ({
                      type: r.type || "text",
                      value: r.value || "",
                      url: r.url ? this.getFullImageUrl(r.url) : undefined,
                      caption: r.caption || "",
                      active: r.active !== undefined ? r.active : true,
                      fileObject: null,
                      id: r.id || Date.now() + Math.random(),
                    }));
                  } else {
                    q.reponses = [];
                  }
                  return {
                    ...q,
                    question: q.question || "",
                    reponses: q.reponses,
                  };
                })
              : [];

            return {
              ...v,
              message_text,
              choix,
            };
          }),
        };
        this.editingId = product.product_id || product.id;
        this.showDialog = true;
      } catch (err) {
        console.error("Erreur lors de l'édition du produit:", err);
      }
    },
    confirmDelete(id) {
      this.productToDeleteId = id;
      this.confirmDialog = true;
    },

    async deleteConfirmed() {
      try {
        const response = await axios.delete(
          `${API_URL}api/mc_chat/product/${this.productToDeleteId}`
        );

        // Fermer la boîte de confirmation

        this.confirmDialog = false;

        // Fermer la boîte d'édition (dialog produit)
        this.showDialog = false;
        // Afficher un toast de succès si la suppression a réussi
        if (response.data && !response.data.error) {
          this.$toast.add({
            severity: "success",
            summary: "Succès",
            detail: response.data.message || "Produit supprimé avec succès",
            life: 3000,
          });
        } else {
          // Si backend renvoie une erreur dans la réponse
          this.$toast.add({
            severity: "warn",
            summary: "Attention",
            detail: response.data.message || "Problème lors de la suppression",
            life: 3000,
          });
        }

        // Rafraîchir la liste des produits
        this.fetchProducts();
      } catch (error) {
        console.error("Erreur lors de la suppression :", error);

        // Afficher un toast d'erreur en cas de problème réseau ou serveur
        const errorMsg =
          error.response?.data?.message ||
          "Erreur serveur lors de la suppression";
        this.$toast.add({
          severity: "error",
          summary: "Erreur",
          detail: errorMsg,
          life: 3000,
        });
      }
    },

    async duplicateProduct(product) {
      try {
        const copy = {
          product_name: product.product_name + " (copie)",
          product_url: product.product_url,
          message_text: product.message_to_send?.text || "",
          send_text_first: product.send_text_first,
          key_product: product.key_product,
        };

        const formData = new FormData();
        formData.append("product_name", copy.product_name);
        formData.append("product_url", copy.product_url);
        formData.append("message_text", copy.message_text);
        formData.append("send_text_first", copy.send_text_first ? "1" : "0");
        formData.append("key_product", copy.key_product);

        // Dupliquer les images (uniquement les URL + caption, sans reupload)
        if (product.message_to_send?.images?.length) {
          const existingImages = product.message_to_send.images.map((img) => ({
            url: img.url,
            caption: img.caption,
            file: null,
          }));
          formData.append("existingImages", JSON.stringify(existingImages));
        }

        await axios.post(`${API_URL}api/mc_chat/products`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        this.fetchProducts();
        this.$toast.add({
          severity: "success",
          summary: "Succès",
          detail: "Produit dupliqué",
          life: 3000,
        });
      } catch (error) {
        console.error("Erreur duplication :", error);
        this.$toast.add({
          severity: "error",
          summary: "Erreur",
          detail: "Impossible de dupliquer",
          life: 3000,
        });
      }
    },

    async toggleActivation(product) {
      const newStatus = product.etat ? 0 : 1;
      console.log("activation", product);

      try {
        await axios.put(
          `${API_URL}api/mc_chat/product/${product.product_id}/status`,
          {
            etat: newStatus,
          }
        );

        product.etat = newStatus; // MAJ locale
        this.$toast.add({
          severity: "success",
          summary: "Succès",
          detail: `Produit ${newStatus ? "activé" : "désactivé"}`,
          life: 3000,
        });
      } catch (error) {
        console.error("Erreur mise à jour statut:", error);
        this.$toast.add({
          severity: "error",
          summary: "Erreur",
          detail: "Changement de statut échoué",
          life: 3000,
        });
      }
    },
  },
};

document.querySelectorAll(".p-dropdown .p-dropdown-trigger").forEach((el) => {
  el.style.height = "10px";
});
</script>

<style scoped>
.field {
  margin-bottom: 1rem;
}

.input-field {
  width: 60%;
}

@media (max-width: 768px) {
  .input-field {
    width: 100% !important; /* Pleine largeur sur mobile */
  }
}

@media (max-width: 768px) {
  .p-button {
    width: 100% !important; /* Boutons plein largeur sur mobile */
    font-size: 1rem !important;
  }
  .mb-3 {
    margin-bottom: 1rem !important;
  }
}

.image-thumbnails {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.thumb-wrapper {
  text-align: center;
  cursor: zoom-in;
}

.thumb-img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  transition: transform 0.2s ease;
}

.thumb-img:hover {
  transform: scale(1.1);
}

.caption {
  font-size: 0.75rem;
  margin-top: 0.25rem;
  color: #555;
}

.zoom-dialog .p-dialog-content {
  padding: 0;
  text-align: center;
}

.zoom-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
}

.zoom-image {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 8px;
}

.zoom-caption {
  margin-top: 1rem;
  font-size: 1rem;
  color: #444;
}

.row-paire {
  background-color: #f0f4f8; /* bleu-gris très clair */
}

.row-impaire {
  background-color: #ffffff; /* blanc ou autre */
}

.p-menuitem {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  cursor: pointer;
}
.p-menuitem:hover {
  background-color: #f0f0f0;
  border-radius: 4px;
}

.p-datatable-tbody > tr:hover {
  background-color: #e0f7ff !important;
}

.row-paire,
.row-impaire {
  border-bottom: 1px solid #ddd;
}

::v-deep .p-datatable .row-paire {
  background-color: #f0f4f8 !important;
}

::v-deep .p-datatable .row-impaire {
  background-color: #ffffff !important;
}

/* Boutons de formulaire : plus visibles */
.p-button-success {
  font-weight: 600;
  border-radius: 0.375rem; /* arrondi */
  box-shadow: 0 2px 6px rgba(0, 128, 0, 0.3);
}

.p-button-danger {
  font-weight: 600;
  border-radius: 0.375rem;
  box-shadow: 0 2px 6px rgba(255, 0, 0, 0.3);
}

/* Boutons d’interface : plus légers */
.p-button-info {
  background-color: #209cee;
  border-color: #209cee;
  color: white;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.p-button-info:hover {
  background-color: #1177cc;
  border-color: #1177cc;
}

/* Boutons textuels : minimalistes */
.p-button-text {
  color: #555;
  font-weight: 500;
}

.variation-title {
  font-weight: 600;
  font-size: 1.3rem;
  color: #ffffff; /* bleu doux */
  background-color: #000; /* fond bleu clair pastel */
  padding: 0.3rem 0.6rem;
  border-radius: 4px;
  display: inline-block;
  margin-bottom: 0.6rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.custom-button {
  background: linear-gradient(45deg, #013382, #388e3c); /* dégradé vert */
  border: none;
  color: white;
  font-weight: 600;
  font-size: 1rem;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
  transition: background 0.3s ease, box-shadow 0.3s ease;
}

.custom-button:hover {
  background: linear-gradient(45deg, #388e3c, #013382);
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.25);
}

.custom-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(72, 180, 97, 0.5);
}

.p-dropdown .p-dropdown-label {
  /* background: transparent;
  border: 0 none;
  width: 200px !important; 
  min-width: 200px;
  max-width: 200px;
  height: 40px !important; 
  min-height: 40px;
  max-height: 40px;
  overflow: hidden;*/
}

.p-dropdown-trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  width: 120px !important;
  height: 30px !important;

  background: #ffffff !important;
  color: #6c757d;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;

  box-sizing: border-box;
  overflow: hidden;
}

.p-inputtext {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  color: #495057;
  background: #ffffff;
  padding: 0.75rem 0.75rem;
  border: 1px solid #ced4da;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s;
  appearance: none;
  border-radius: 6px;
  width: 200px !important;
  height: 50px !important;
}

.p-inputtextarea {
  resize: both !important;
  min-width: 300px;
  min-height: 160px;
}
</style>
